import { File } from './../../models/files/files.model';
import { Category } from './../../models/categories/categories.model';
import { Testimonial } from '../testimonials/testimonials.model';
import { Form } from '../forms/forms.model';

export class Product {
    id?: string;
    title?: any;
    content?: any;
    custom_seo_data?: any;
    seo_title?: any;
    seo_description?: any;
    released?: Date;
    contained?: IContained;
    form?: Form;
    availableCategories?: Category[];
    related_products: Array<Product>;
    testimonials: Array<Testimonial>;

    constructor(options: any) {
        this.id = options.id;
        this.title = options.title;
        this.content = options.content;
        this.custom_seo_data = options.custom_seo_data;
        this.seo_title = options.seo_title;
        this.seo_description = options.seo_description;
        this.released = new Date(options.released);
        this.contained = options.contained;
        this.form = options.form;
        this.availableCategories = options.availableCategories;
        this.related_products = options.related_products;
        this.testimonials = options.testimonials;
    }
}

interface IContained {
    files?: Array<File>;
    categories?: Array<any>;
}
